import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useMonitoringServers } from "@/hooks/useMonitoring";
import { ServerHealthRow } from "./ServerHealthRow";

export const InfrastructureHealthCard: React.FC = () => {
  const { t } = useTranslation();
  const { data: servers, isLoading, isError } = useMonitoringServers();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base font-semibold">
          {t("analytics.platform.health.title")}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        {isLoading && (
          <p className="text-sm text-muted-foreground">{t("common.loading")}</p>
        )}
        {isError && (
          <p className="text-sm text-destructive">
            {t("analytics.platform.health.error")}
          </p>
        )}
        {!isLoading && !isError && !servers?.length && (
          <p className="text-sm text-muted-foreground">
            {t("analytics.platform.health.empty")}
          </p>
        )}
        {servers?.map((server) => (
          <ServerHealthRow key={server.id} server={server} />
        ))}
      </CardContent>
    </Card>
  );
};
